const enumToList = <T extends object>(val: T) => {
  return Object.entries(val).reduce((acc, [value, label]) => [...acc, { value, label }], []);
};

const enumUtil = {
  enumToList,
};

export default enumUtil;
